<template>
  <div class="root-container">
    <el-divider></el-divider>
    <div class="g-flex-sb-start">

      <div class="link-item link-item1">
        <div class="title">产品分类</div>
        <ul>
          <li v-for="(item, index) in linksData.products" :key="index">
            <a :href="item.url">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <div class="link-item link-item2">
        <div class="title">解决方案</div>
        <ul>
          <li v-for="(item, index) in linksData.solution" :key="index">
            <a :href="item.url">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <div class="link-item link-item3">
        <div class="title">关于集团</div>
        <ul>
          <li v-for="(item, index) in linksData.about" :key="index">
            <a :href="item.url">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <!-- 二维码 -->
      <div class="link-item link-item4">
        <div>
          <img :src="linksData.merchantServiceNum" alt="" style="margin-right: 10px;">
          <img :src="linksData.merchantApp" alt="">
        </div>
        <div class="connact">
          <i class="el-icon-phone"></i>
          咨询电话：400 0063 888
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { getLinks } from '@/api/login'

export default {
  name: 'aboutLink',
  data () {
    return {
      linksData: {}
    }
  },
  async created () {
    const { code, result } = await getLinks()
    if (code !== 200) return
    this.linksData = result
  }
}
</script>
<style lang="less" scoped>
  .root-container {
    width: 100%;
    min-width: 500px;
    background-color: #2e3033;
    padding: 30px 80px;
    color: #fff;
    /deep/ .el-divider {
      background-color: #454547;
    }
    .link-item ul li {
      width: 160px;
      font-size: 14px;
      font-weight: 600;
      color: #919192;
      display: inline-block;
      line-height: 30px;
      margin-right: 40px;
    }
    .link-item1 {
      width: 40%;
    }
    .link-item2, .link-item3 {
      width: 15%;
    }
    .link-item4 {
      width: 30%;
      img {
        width: 150px;
        height: 150px;
      }
    }
    .connact {
      width: 310px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-weight: 600;
      background-color: #2d6df6;
      margin-top: 20px;
    }
  }
</style>